
import axiosMiddleware from './axiosMiddleware'
import env from '../config/env'

const requestOTP = async (params) => axiosMiddleware(env.BACKEND_END_POINT).post('/RequestOTP', params)

export default requestOTP
